import clsx from 'clsx'
import React from 'react'
import {makeStyles} from 'external/material'
import Box from '@mui/material/Box'
import Button from '@mui/material/Box'
import BackButton from 'components/back-button'
import moment from 'helpers/moment'

const useStyles = makeStyles(infoBarStyles)

export default function InfoBar ({context, save, showSave}) {
    const classes = useStyles()
    const {homeworkContext, translate, link, linkQuery, homeworkId, updateState} = context      
    const {review} = homeworkContext
    const homework = homeworkContext.homeworks ? homeworkContext.homeworks.items.find(h=> h.id == homeworkId): {}

    function formatDate (date) {
      return moment(date).format(context.languageId == 'es' ? 'DD/MM/YYYY' : 'MM/DD/YYYY')
    }

    function handleBackButton(e) {
      updateState({homeworkContext: {review: {from: {$set: undefined}, query: {$set: undefined}}}})
    }

    if(!homework) return (<></>)

    const backLink = review.from
      ? linkQuery(review.from, review.query)
      : (false /*calendarContext.lastDate*/ ? link({page: 'calendar'}) : link({homeworkId: undefined}))

    return (
        <Box className={classes.root}>
            <Box>
              <BackButton onClick={handleBackButton} link={backLink} />            
            </Box>
            <Box className={clsx(classes.middle, classes.label)}>
              {translate('homework')}: {homework ? homework.title :''}
            </Box>
            <Box className={clsx(classes.homeworkDates)}>
              <div>
                <span>{translate('homework-from-date')}</span>: &nbsp; {formatDate(homework.startDate)}
              </div>
              <div>
                <span>{translate('homework-to-date')}</span>: &nbsp; {formatDate(homework.startDate)}
              </div>
            </Box>
            {showSave && ( 
              <Button
                  variant="contained"
                  className={clsx(classes.button, "save")}
                  onClick={save}
                  >
                  {translate('save')}
              </Button>
            )}
        </Box>
    )
}

function infoBarStyles() {
  return {
    root: {
        display: 'flex',
        minHeight: '60px',
        maxHeight: '60px',
        '& svg': {
            fill: '#4f556d'
        },
        '& a.MuiIconButton-root': {
            margin: 0,
            padding: '17px 12px',
            borderRight: '1px solid #ddd',
            borderRadius: 0
        }
    },
    avatar: {
      fontSize: '25pt',
      color: '#09b1b2'
    },
    middle: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
    label: {
      marginLeft: '10px',
      fontSize: '14pt',
      flexGrow: 1,      
    },
    homeworkDates: {
      padding: 10,
      '& div': {
        textAlign: 'right'
      },
      '& span': {
        fontWeight: 'bold'
      }
    },
    button: {
        width: 120,
        fontSize: "13pt",
        textTransform: "none",
        boxShadow: 'none',
        borderRadius: 4,
        margin: 10,
        textAlign: 'center',
        padding: 7,
        cursor: 'pointer',
        "&.save" : {
          color: "#fff",
          border: 'solid 1px #2c75bd',
          backgroundColor: '#2c75bd',
          color: '#fff',
          textTransform: 'capitalize',          
          '&:hover': {
            backgroundColor: '#29739f',
            borderColor: '#29739f',
            boxShadow: 'none',
          },
        }
      }
  }
}
